export default __webpack_public_path__ + "static/media/news_radio_mobile.ac00a46c.png";